import React from 'react'
import Image from 'next/image'
import useTranslation from 'next-translate/useTranslation'
import { Text } from 'components/Text'
import {
  HeroRoot,
  ContentWrapper,
  ImageWrapper,
  QuoteWrapper,
  Description,
} from './Hero.styles'
import thumbnail from '../../../../../public/assets/reviews/hero.webp'
import Trans from 'next-translate/Trans'
import { SectionTitle } from 'features/Reviews/Reviews.styles'
export const Hero: React.FC = () => {
  const { t } = useTranslation('reviews')

  return (
    <HeroRoot>
      <ContentWrapper>
        <ImageWrapper>
          <Image objectFit="cover" src={thumbnail} alt={t('reviews:hero.imageAlt')} layout="fill" />
        </ImageWrapper>
        <QuoteWrapper>
          <Text
            display={{ '@initial': 'none', '@bp2': 'block' }}
            align="center"
            size={{
              '@initial': 'h3',
              '@bp3_1': 'h2',
              '@bp4': 'h1',
            }}
            color="accent-white"
            weight="regular"
          >
            <Trans components={{ br: <br /> }} i18nKey={'reviews:hero.quote'} />
          </Text>
          <SectionTitle className="mobile-only" color="secondary" align="center">
            <Trans i18nKey="reviews:hero.quote" />
          </SectionTitle>
          <Description
            className="desktop-only"
            align="center"
            size="body"
            color="accent-white"
          >
            {t('reviews:hero.description')}
          </Description>
          <Description className="mobile-only" align="center" size="body" color="accent-white">
            {t('reviews:hero.description-mobile')}
          </Description>
        </QuoteWrapper>
      </ContentWrapper>
    </HeroRoot>
  )
}
